import { defineStore } from 'pinia'

import state from './state'
import getters from './getters'
import actions from './actions'

const useIncidencesStore = defineStore('incidences', {
  state,
  getters,
  actions
})

export default useIncidencesStore
